import {Divider, Flex} from 'antd';
import React, {useEffect, useState} from 'react';

import supplierImage from '../../../../assets/supplierImage.png';
import {upstreamKey} from '../../../../components/Forms/Constants/IP/UpstreamKeyLabel';
import PopoverMapData from '../../../../components/Table/Popover/PopoverMapData';

const SupplierMapData: React.FC<{
  mapRef: any[];
  data: any[];
  setEditData: React.Dispatch<any>;
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>;
  handleDelete: (_id: string[] | string) => void;
  setShowModel: React.Dispatch<React.SetStateAction<boolean>>;
  type: string;
  selectedFacility?: string;
  setSelectedFacility: React.Dispatch<React.SetStateAction<string | undefined>>;
}> = ({
  mapRef,
  data,
  handleDelete,
  setEditData,
  setIsEdit,
  setShowModel,
  type,
  selectedFacility,
  setSelectedFacility
}) => {
  const [showPopup, setShowPopup] = useState<boolean[]>(
    Array(data.length).fill(false)
  );
  const singleRef: any[] = [];

  useEffect(() => {
    const index = data?.findIndex((t) => t?._id === selectedFacility);
    singleRef[index]?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
  }, [selectedFacility]);

  return (
    <div>
      <div className="supplierListContainer">
        {data.map((items: any, index: number) => {
          const isSelectedFacility = selectedFacility === items._id;

          return (
            <div
              key={index}
              ref={(ref) => singleRef?.push(ref)}
              onClick={() => {
                mapRef[index].fire('click');
                setSelectedFacility(items._id);
              }}
            >
              <div
                className="supplierContainer"
                style={{
                  backgroundColor: isSelectedFacility ? '#DDF7FA39' : '#FFFFFF',
                  borderLeft: isSelectedFacility ? '2px solid #3BB3C1' : ''
                }}
              >
                <Flex
                  vertical={false}
                  style={{
                    cursor: 'pointer'
                  }}
                >
                  <div className="supplierImage">
                    <img src={supplierImage} height={68} width={68} />
                  </div>
                  <div className="supplierData">
                    <div className="supplierName">{items.name}</div>
                    {type === 'up' && (
                      <>
                        <div className="environmentalSustainable">
                          <div>
                            {`Environmental Criteria : 
                        ${
                          items?.[upstreamKey.ENV_CRITERIA] === true
                            ? 'Yes'
                            : 'No'
                        }`}
                          </div>
                          <div>
                            Sustainable Sourcing :
                            {items?.[upstreamKey.SUSTAINABLE_SOURCING] === true
                              ? ' Yes'
                              : ' No'}
                          </div>
                        </div>
                      </>
                    )}
                    <div className="mobileEmailAddress">
                      <div>{items?.[upstreamKey.MOBILE]}</div>
                      <div>{items?.[upstreamKey.EMAIL]}</div>
                      <div className="address">{`${items.fullAddress}`}</div>
                    </div>
                  </div>
                </Flex>
                <div className="threeDotIcon">
                  <PopoverMapData
                    setEditData={setEditData}
                    setIsEdit={setIsEdit}
                    handleDelete={handleDelete}
                    setShowModel={setShowModel}
                    showPopup={showPopup}
                    setShowPopup={setShowPopup}
                    items={items}
                    index={index}
                  />
                </div>
              </div>
              <Divider style={{margin: '0px'}} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SupplierMapData;
